import styled from 'styled-components';
import { device } from 'components/styles/MediaQuery';

export const ScNewPassword = styled.div`
  & button {
    display: block;
    max-width: 232px;
    margin: 32px auto 0;

    &.fr,
    &.fr-CA {
      font-size: 14px;
    }

    @media (${device.mobile}) {
      max-width: none;
      width: 100%;
    }
  }
`;
